import ModalsRouter, { modalPaths } from './ModalsRouter';

export { modalPaths };

export default ModalsRouter;
